;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"8190caddea567ba95bb8027f8c01cd714d180918"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/play";import * as Sentry from '@sentry/nextjs';

import {
  CORE_ERROR_PATTERNS,
  createBeforeSend,
  PHASER_ERROR_PATTERNS,
  WEBRTC_ERROR_PATTERNS,
  WHALE_BROWSER_ERROR_PATTERNS,
} from '@zep/sentry';

import baseOptions from '../../sentry.base.config';

Sentry.init({
  ...baseOptions,
  beforeSend: createBeforeSend({
    ignorePatterns: [
      ...CORE_ERROR_PATTERNS,
      ...PHASER_ERROR_PATTERNS,
      ...WEBRTC_ERROR_PATTERNS,
      ...WHALE_BROWSER_ERROR_PATTERNS,
    ],
  }),
});
